import { InferGetStaticPropsType, NextPage } from 'next'
import Head from 'next/head'
import ErrorPage from 'next/error'

import { initializeApollo } from '~/lib/apollo'
import {
  getServerPageWork,
  getServerPageWorks,
  Stage,
} from 'generated/graphql.api'

import WorksPageTemplate from '~/components/templates/WorksPageTemplate'

type Props = InferGetStaticPropsType<typeof getStaticProps>

const WorkPage: NextPage<Props> = props => {
  if (!props.data) {
    return <ErrorPage statusCode={404} />
  }

  const { title, coverImage, description, slug } = props.data.page.edges[0].node

  const pageUrl = `https://edu-ad.com/blog/${slug}`

  return (
    <>
      <Head>
        <title>{title} | eduad</title>
        <meta name='description' content={description} />
        <meta property='og:url' content={pageUrl} />
        <meta property='og:type' content='article' />
        <meta property='og:title' content={`${title} | eduad`} />
        <meta property='og:description' content={description} />
        <meta property='og:site_name' content='eduad' />
        <meta property='og:image' content={coverImage.url} />
        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:url' content={pageUrl} />
        <meta name='twitter:site' content='@edu_ad_official' />
        <meta name='twitter:title' content={title} />
        <meta name='twitter:description' content={description} />
        <meta name='twitter:image' content={coverImage.url} />
      </Head>
      <WorksPageTemplate data={props.data} />
    </>
  )
}

export const getStaticPaths = async () => {
  const client = initializeApollo()
  const data = await getServerPageWorks(
    {
      variables: {
        stage: Stage.Published,
      },
    },
    client
  )
  const paths = data.props.data.page.edges.map(
    item => `/works/${item.node.slug}`
  )
  return { paths, fallback: true }
}

export const getStaticProps = async ({
  params,
  preview = false,
  initialState,
}) => {
  const client = initializeApollo(initialState)
  const slug = params.slug.toString()
  const data = await getServerPageWork(
    { variables: { slug, stage: preview ? Stage.Draft : Stage.Published } },
    client
  )
  return {
    props: { preview, data: data.props.data },
    revalidate: 60,
  }
}

export default WorkPage
